import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Config = {
  minDeliveryCharges: number;
  minDelivery: number;
  minFreeItemDelivery: number;
  canShowQR: boolean;
  canShowCustomizations: boolean,
  canShowCalory: boolean
};

export type AppReducerState = {
  config: Config;
  paymentMethod: { [key: string]: any };
  currentLocation: any;
  userPoints: number;
  deliveryAddress: { [key: string]: any };
  disabledModifiers?: any[];
  disabledMenuItems: any[];
  orderMode: string;
  selectedSiteId: number;
  sitesOrderModes: any[];
  openBottomSheet: boolean
};

const initialState = {
  config: {
    minDeliveryCharges: 0,
    minDelivery: 0,
    minFreeItemDelivery: 0,
    canShowQR: true,
    canShowCustomizations: false,
    canShowCalory: false
  },
  paymentMethod: {},
  currentLocation: null,
  userPoints: 0,
  deliveryAddress: {},
  disabledModifiers: [],
  disabledMenuItems: [],
  orderMode: "",
  selectedSiteId: -1,
  sitesOrderModes: [],
  openBottomSheet: false
};

// slice
export const appReducer = createSlice({
  name: "appReducer",
  initialState: initialState,
  reducers: {
    setPaymentMethod: (
      state,
      action: PayloadAction<{ [key: string]: any }>
    ) => {
      state.paymentMethod = action.payload;
    },
    setCurrentLocation: (state, action: PayloadAction<any>) => {
      state.currentLocation = action.payload;
    },
    removePaymentMethod: (state) => {
      state.paymentMethod = {};
    },
    setUserPoints: (state, action: PayloadAction<any>) => {
      const { userPoint } = action.payload;
      state.userPoints = userPoint;
    },
    updateUserPoints: (state, action: PayloadAction<number>) => {
      state.userPoints += action.payload;
    },
    substractUserPoints: (state, action: PayloadAction<number>) => {
      state.userPoints -= action.payload;
    },
    removeUserPoints: (state) => {
      state.userPoints = 0;
    },
    setConfig: (state, action: PayloadAction<any>) => {
      state.config = action.payload;
    },
    setDeliveryAddress: (state, action: PayloadAction<any>) => {
      state.deliveryAddress = action.payload;
    },
    setDisabledModifiers: (state, action: PayloadAction<any>) => {
      state.disabledModifiers = action.payload;
    },
    setDisabledMenuItems: (state, action: PayloadAction<any>) => {
      state.disabledMenuItems = action.payload;
    },
    setOrderMode: (state, action: PayloadAction<any>) => {
      state.orderMode = action.payload;
    },
    setSitesOrderModes: (state, action: PayloadAction<any>) => {
      state.sitesOrderModes = action.payload;
    },
    setSelectedSiteId: (state, action: PayloadAction<number>) => {
      state.selectedSiteId = action.payload;
    },
    setOpenBottemSheet: (state, action: PayloadAction<boolean>) => {
      state.openBottomSheet = action.payload;
    }
  },
});

export const {
  setPaymentMethod,
  removePaymentMethod,
  setCurrentLocation,
  setUserPoints,
  updateUserPoints,
  substractUserPoints,
  removeUserPoints,
  setDeliveryAddress,
  setConfig,
  setDisabledModifiers,
  setDisabledMenuItems,
  setOrderMode,
  setSitesOrderModes,
  setSelectedSiteId,
  setOpenBottemSheet
} = appReducer.actions;
